import useConstructor from "./useConstructor";
import useDestructor from "./useDestructor";

const useLoginOTPLifeCycle = () => {
  useConstructor();
  useDestructor();
};

export default useLoginOTPLifeCycle;
